// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1KKNq","title":"FrontImage_title__2hqw4"};